/**
 * @param {String} date
 * @param {String} format
 * @return {String}
 */
export function dateFormat(date, format = 'D. M. YY') {
    try {
        const object = new Date(date);
        return object.getDate() + '. ' + (object.getMonth() + 1) + '. ' + object.getFullYear();
    } catch (e) {
        return null;
    }
}
